var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHulkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 33,
    viewBox: "0 0 66 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5703 27.8444H27.4609V21.7897H21.1035V27.8444H18.9844V13.6647H21.1035V19.7455H27.4609V13.6647H29.5703V27.8444Z",
    fill: "url(#paint0_linear_846_65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.334 24.2637C42.334 24.9017 42.2852 25.3965 42.1875 25.735C42.0508 26.2038 41.7969 26.6205 41.416 26.9981C41.0352 27.3757 40.625 27.6231 40.2051 27.7403C39.9121 27.8054 39.4336 27.8444 38.7695 27.8444H35.459C34.8242 27.8444 34.3457 27.8054 34.043 27.7142C33.5938 27.597 33.1836 27.3626 32.8223 27.0111C32.4219 26.6074 32.1484 26.1778 32.0117 25.7481C31.9238 25.4486 31.8848 24.9538 31.8848 24.2767V13.6778H34.0039V23.8861C34.0039 24.6283 34.1504 25.1231 34.4434 25.3835C34.7363 25.6439 35.2637 25.7741 36.0254 25.7741H38.2031C38.9551 25.7741 39.4824 25.6439 39.7754 25.3965C40.0684 25.1491 40.2246 24.6673 40.2246 23.9382V13.6647H42.3438V24.2637H42.334Z",
    fill: "url(#paint1_linear_846_65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0918 27.8444H48.4668C47.2363 27.8444 46.2891 27.597 45.625 27.0892C44.9707 26.5814 44.6387 25.696 44.6387 24.446V13.6517H46.7578V23.9382C46.7578 24.6674 46.9336 25.1752 47.2754 25.4616C47.5391 25.683 48.0957 25.7872 48.9551 25.7872H54.0918V27.8444Z",
    fill: "url(#paint2_linear_846_65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4805 27.8444H55.3613V13.6647H57.4805V27.8444ZM65.5078 27.8444H63.0078L58.1934 21.8809C57.7637 21.36 57.5488 20.9694 57.5488 20.696C57.5488 20.4486 57.7539 20.058 58.1738 19.5371L62.832 13.6778H65.3613L59.834 20.6699L65.5078 27.8444Z",
    fill: "url(#paint3_linear_846_65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 21.7898C16.0938 21.1387 15.8106 20.5658 15.3907 20.3054C15.2052 20.1882 15.0782 19.9538 15.0782 19.6804V18.5866C15.0782 18.3262 15.2052 18.1049 15.381 18.0007C15.9083 17.6752 16.2306 16.8809 16.045 16.0215C15.9376 15.5137 15.6251 15.0971 15.2345 14.9408C14.8146 14.7715 14.4239 14.9017 14.131 15.1882C13.9649 15.3575 13.7403 15.3445 13.5548 15.2142L13.0274 14.8106C12.8517 14.6804 12.754 14.433 12.7735 14.1726C12.7931 13.8471 12.7442 13.4955 12.5392 13.1179C12.3438 12.7403 12.0313 12.4538 11.6798 12.4017C10.9278 12.2846 10.3028 13.0658 10.3028 14.0424C10.3028 14.8497 10.7423 15.5267 11.3185 15.657V17.3366C11.3185 17.6101 11.1915 17.8445 11.006 17.9616C10.752 18.1179 10.547 18.3913 10.4298 18.7299C10.3419 18.9773 10.1661 19.1596 9.96103 19.1596H9.84385C9.63877 19.1596 9.46299 18.9903 9.3751 18.7299C9.17002 18.1309 8.7208 17.7273 8.20322 17.7273C7.68564 17.7273 7.23643 18.1439 7.03135 18.7299C6.94346 18.9773 6.76768 19.1596 6.5626 19.1596H6.10361C5.9083 19.1596 5.74229 18.9903 5.66416 18.7559C5.43955 18.1179 4.92197 17.7012 4.3458 17.8184C3.83799 17.9226 3.41807 18.4695 3.33017 19.1465C3.19346 20.1882 3.78916 21.0997 4.55088 21.0997C5.03916 21.0997 5.46885 20.7221 5.66416 20.1622C5.75205 19.9148 5.92783 19.7455 6.13291 19.7455H6.57236C6.77744 19.7455 6.95322 19.9148 7.04111 20.1752C7.24619 20.7741 7.69541 21.1778 8.21299 21.1778C8.73057 21.1778 9.17979 20.7611 9.38486 20.1752C9.47275 19.9278 9.64853 19.7455 9.85361 19.7455H9.99033C10.1856 19.7455 10.3517 19.9148 10.4395 20.1491C10.6837 20.8523 11.2794 21.282 11.9337 21.0346C12.3145 20.8783 12.6271 20.4616 12.7442 19.9538C12.9298 19.0945 12.6075 18.2872 12.0802 17.9616C11.9044 17.8575 11.7774 17.6361 11.7774 17.3627V15.657C11.9532 15.6179 12.1192 15.5137 12.2657 15.3835C12.4317 15.2273 12.6466 15.1882 12.8321 15.3184L13.711 15.9825C13.6622 16.1517 13.6329 16.334 13.6329 16.5293C13.6329 17.1804 13.9161 17.7533 14.336 18.0137C14.5216 18.1309 14.6485 18.3653 14.6485 18.6387V19.7064C14.6485 19.9799 14.5216 20.2142 14.336 20.3314C13.9161 20.5919 13.6329 21.1648 13.6329 21.8158C13.6329 22.4668 13.9161 23.0398 14.336 23.3002C14.5216 23.4174 14.6485 23.6517 14.6485 23.9252V24.9929C14.6485 25.2663 14.5216 25.5007 14.336 25.6179C13.9161 25.8783 13.6329 26.4512 13.6329 27.1023C13.6329 27.3106 13.6622 27.5059 13.7208 27.6882L12.8126 28.4174C12.6368 28.5606 12.422 28.5736 12.256 28.4174C12.0021 28.183 11.6798 28.0658 11.338 28.1569C10.8497 28.2741 10.4493 28.795 10.3517 29.433C10.1759 30.5658 10.879 31.5424 11.7188 31.4122C12.1778 31.334 12.5782 30.8913 12.7345 30.3054C12.8028 30.045 12.8126 29.8106 12.7931 29.5762C12.7638 29.3158 12.8614 29.0684 13.0372 28.9252L13.6231 28.4434C13.7989 28.3002 14.0138 28.2872 14.1798 28.4434C14.4728 28.7168 14.8536 28.821 15.2638 28.6648C15.6446 28.5085 15.9571 28.0918 16.0646 27.584C16.2501 26.7247 15.9278 25.9304 15.4005 25.6049C15.2247 25.5007 15.0978 25.2793 15.0978 25.0189V23.9252C15.0978 23.6517 15.2247 23.4174 15.4103 23.3002C15.8106 23.0137 16.0938 22.4408 16.0938 21.7898Z",
    fill: "url(#paint4_linear_846_65)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4393 25.3184C10.6639 25.9434 11.1815 26.3471 11.7577 26.2169C12.2655 26.1127 12.6757 25.5658 12.7636 24.8887C12.9003 23.8471 12.3046 22.9356 11.5429 22.9356C11.0448 22.9356 10.6151 23.3262 10.4198 23.8991C10.3319 24.1465 10.1561 24.3288 9.95106 24.3288H9.8534C9.63856 24.3288 9.46278 24.1465 9.38465 23.8861C9.18934 23.2741 8.73035 22.8575 8.20301 22.8575C7.67567 22.8575 7.22645 23.2872 7.02137 23.8861C6.93348 24.1465 6.7577 24.3288 6.55262 24.3288H6.11317C5.91785 24.3288 5.75184 24.1596 5.67371 23.9122C5.43934 23.196 4.83387 22.7533 4.17957 23.0007C3.78895 23.1439 3.47645 23.5606 3.36903 24.0814C3.18348 24.9408 3.50574 25.7481 4.03309 26.0736C4.20887 26.1908 4.33582 26.3991 4.33582 26.6726V27.6491C4.33582 27.9226 4.20887 28.157 4.02332 28.2741C3.97449 28.3002 3.92567 28.3393 3.87684 28.3783C3.71082 28.5215 3.49598 28.5606 3.32996 28.4174L2.40223 27.6622C2.45106 27.4799 2.49012 27.2846 2.49012 27.0762C2.49012 26.4252 2.20692 25.8523 1.78699 25.5919C1.60145 25.4747 1.47449 25.2403 1.47449 24.9669V23.8991C1.47449 23.6257 1.60145 23.3913 1.78699 23.2741C2.20692 23.0137 2.49012 22.4408 2.49012 21.7898C2.49012 21.1387 2.20692 20.5658 1.78699 20.3054C1.60145 20.1882 1.47449 19.9538 1.47449 19.6804V18.6127C1.47449 18.3393 1.60145 18.1049 1.78699 17.9877C2.20692 17.7273 2.49012 17.1544 2.49012 16.5033C2.49012 16.308 2.46082 16.1387 2.41199 15.9695L3.2616 15.3314C3.43738 15.2012 3.67176 15.1882 3.83777 15.3575C4.13074 15.6439 4.52137 15.7611 4.93153 15.6049C5.32215 15.4486 5.64442 15.0189 5.75184 14.4851C5.98621 13.3262 5.29285 12.2846 4.44324 12.3887C4.08192 12.4278 3.75965 12.7273 3.55457 13.1309C3.35926 13.5085 3.31043 13.8601 3.32996 14.1726C3.34949 14.433 3.25184 14.6804 3.07606 14.8106L2.54871 15.2143C2.37293 15.3445 2.13856 15.3575 1.97254 15.1882C1.67957 14.9018 1.28895 14.7846 0.869025 14.9408C0.488166 15.0971 0.175665 15.5137 0.0584778 16.0215C-0.127069 16.8809 0.195197 17.6752 0.722541 18.0007C0.898322 18.1049 1.02528 18.3262 1.02528 18.5866V19.6804C1.02528 19.9538 0.898321 20.1882 0.712774 20.3054C0.292852 20.5658 0.00964966 21.1387 0.00964966 21.7898C0.00964966 22.4408 0.292852 23.0137 0.712774 23.2741C0.898321 23.3913 1.02528 23.6257 1.02528 23.8991V24.9929C1.02528 25.2533 0.898322 25.4747 0.722541 25.5788C0.195197 25.9044 -0.127069 26.6986 0.0584778 27.558C0.1659 28.0658 0.478399 28.4825 0.859259 28.6387C1.26941 28.808 1.65027 28.6908 1.94324 28.4174C2.10926 28.2611 2.33387 28.2741 2.49988 28.4174L3.08582 28.8991C3.25184 29.0294 3.34949 29.2898 3.32996 29.5502C3.30067 29.8366 3.32996 30.1361 3.44715 30.4616C3.61317 30.9174 3.9452 31.282 4.31629 31.3731C5.10731 31.5684 5.7909 30.7741 5.7909 29.7585C5.7909 29.1075 5.5077 28.5346 5.08777 28.2741C4.90223 28.157 4.77528 27.9226 4.77528 27.6491V26.6986C4.77528 26.4252 4.90223 26.1908 5.08777 26.0736C5.33192 25.9174 5.53699 25.657 5.66395 25.3314C5.75184 25.084 5.92762 24.9148 6.1327 24.9148H6.59168C6.79676 24.9148 6.97254 25.084 7.06043 25.3314C7.26551 25.9174 7.71473 26.308 8.22254 26.308C8.74012 26.308 9.17957 25.9044 9.38465 25.3314C9.47254 25.084 9.64832 24.9148 9.8534 24.9148H9.99988C10.1854 24.9148 10.3514 25.084 10.4393 25.3184Z",
    fill: "url(#paint5_linear_846_65)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5684C0 11.5684 2.06054 6.9851 11.5918 9.39396C21.123 11.8028 27.6562 11.4512 37.8711 10.9955C48.0957 10.5398 54.5312 8.36531 59.6875 12.3757C59.6875 12.3757 58.7402 7.88354 44.4043 8.70385C30.0684 9.52416 15.3711 8.83406 11.4258 7.79239C7.4707 6.75072 1.54297 7.10229 0 11.5684Z",
    fill: "url(#paint6_linear_846_65)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31445 6.56842C2.31445 6.56842 11.0156 5.26634 15.3711 5.8002L12.627 4.04238C12.627 4.04238 17.7539 0.982488 23.6035 1.45124C29.4531 1.90697 33.1836 6.19082 33.1836 6.19082C33.1836 6.19082 30.0391 7.59707 26.709 7.31061C26.709 7.31061 32.4316 8.63874 36.1035 6.88092C36.1035 6.88092 30.4395 0.2403 21.9043 0.00592502C13.3691 -0.22845 2.31445 6.56842 2.31445 6.56842Z",
    fill: "url(#paint7_linear_846_65)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 32.1283V29.8887H18.9941V29.5632H19.9512V29.8887H19.6094V32.1283H19.3359Z",
    fill: "url(#paint8_linear_846_65)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3516 32.1283V29.5632H21.1035V29.8366H20.625V30.6569H20.9668V30.9304H20.625V31.8418H21.1035V32.1153H20.3516V32.1283Z",
    fill: "url(#paint9_linear_846_65)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0312 32.1543C21.9531 32.1543 21.875 32.1413 21.8164 32.1022C21.7578 32.0762 21.709 32.0241 21.6602 31.972C21.6211 31.9199 21.5918 31.8548 21.5625 31.7767C21.5332 31.6986 21.5234 31.6074 21.5137 31.5163C21.5039 31.4252 21.4941 31.321 21.4941 31.2038V30.4746C21.4941 30.3574 21.5039 30.2533 21.5137 30.1621C21.5234 30.071 21.543 29.9798 21.5625 29.9017C21.5918 29.8236 21.6211 29.7585 21.6602 29.7064C21.6992 29.6543 21.748 29.6153 21.8164 29.5762C21.875 29.5502 21.9531 29.5241 22.0312 29.5241C22.1191 29.5241 22.1973 29.5371 22.2656 29.5762C22.334 29.6153 22.3828 29.6673 22.4219 29.7324C22.4609 29.7975 22.4902 29.8757 22.5098 29.9668C22.5293 30.058 22.5391 30.1621 22.5488 30.2793C22.5488 30.2923 22.5488 30.3314 22.5488 30.3574H22.2754V30.2793C22.2754 30.2272 22.2754 30.1882 22.2754 30.1491C22.2754 30.11 22.2656 30.071 22.2656 30.0319C22.2559 29.9929 22.2559 29.9668 22.2363 29.9408C22.2266 29.9147 22.207 29.8887 22.1973 29.8757C22.1777 29.8496 22.1582 29.8366 22.1289 29.8236C22.0996 29.8106 22.0703 29.8106 22.041 29.8106C21.9922 29.8106 21.9629 29.8236 21.9238 29.8366C21.8945 29.8496 21.8652 29.8757 21.8457 29.9147C21.8262 29.9408 21.8164 29.9798 21.8066 30.0319C21.7969 30.084 21.7871 30.1361 21.7871 30.1752C21.7871 30.2272 21.7871 30.2793 21.7871 30.3574V31.2689C21.7871 31.334 21.7871 31.3861 21.7969 31.4382C21.7969 31.4903 21.8066 31.5423 21.8164 31.5814C21.8262 31.6335 21.8457 31.6725 21.8652 31.7116C21.8848 31.7507 21.9043 31.7767 21.9336 31.7897C21.9629 31.8158 22.002 31.8158 22.041 31.8158C22.0801 31.8158 22.1191 31.8028 22.1484 31.7897C22.1777 31.7637 22.1973 31.7377 22.2168 31.7116C22.2363 31.6856 22.2461 31.6335 22.2559 31.5814C22.2656 31.5293 22.2754 31.4772 22.2754 31.4382C22.2754 31.3861 22.2754 31.334 22.2754 31.2689V31.1778H22.5488V31.2689C22.5488 31.3991 22.5391 31.5163 22.5195 31.6205C22.5 31.7246 22.4707 31.8028 22.4316 31.8809C22.3926 31.959 22.3438 32.0111 22.2754 32.0502C22.207 32.1413 22.1289 32.1543 22.0312 32.1543Z",
    fill: "url(#paint10_linear_846_65)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9883 32.1283V29.5632H23.2617V30.6569H23.7402V29.5632H24.0137V32.1283H23.7402V30.9434H23.2617V32.1283H22.9883Z",
    fill: "url(#paint11_linear_846_65)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5605 32.1283V29.5632H24.7656L25.2441 31.1517V29.5632H25.5176V32.1283H25.3223L24.834 30.4225V32.1283H24.5605Z",
    fill: "url(#paint12_linear_846_65)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5527 32.1543C26.4551 32.1543 26.377 32.1283 26.3086 32.0892C26.2402 32.0502 26.1816 31.9981 26.1426 31.92C26.1035 31.8418 26.0742 31.7507 26.0547 31.6595C26.0352 31.5554 26.0254 31.4382 26.0254 31.308V30.3835C26.0254 30.2533 26.0352 30.1361 26.0547 30.0319C26.0742 29.9278 26.1035 29.8497 26.1426 29.7715C26.1816 29.6934 26.2402 29.6413 26.3086 29.6023C26.377 29.5632 26.4648 29.5502 26.5527 29.5502C26.7383 29.5502 26.875 29.6153 26.9629 29.7585C27.0508 29.9017 27.0898 30.1101 27.0898 30.3835V31.308C27.0898 31.4382 27.0801 31.5554 27.0605 31.6595C27.041 31.7637 27.0117 31.8549 26.9727 31.92C26.9336 31.9981 26.875 32.0502 26.8066 32.0892C26.7383 32.1413 26.6504 32.1543 26.5527 32.1543ZM26.3574 31.7377C26.3965 31.8158 26.4648 31.8549 26.5527 31.8549C26.6504 31.8549 26.7187 31.8158 26.748 31.7377C26.7871 31.6595 26.8066 31.5424 26.8066 31.3991V30.2924C26.8066 30.1491 26.7871 30.0319 26.748 29.9538C26.709 29.8757 26.6406 29.8496 26.543 29.8496C26.4453 29.8496 26.377 29.8887 26.3379 29.9538C26.2988 30.0319 26.2793 30.1361 26.2793 30.2924V31.3991C26.2988 31.5424 26.3184 31.6595 26.3574 31.7377Z",
    fill: "url(#paint13_linear_846_65)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5879 32.1283V29.5632H27.8613V31.8548H28.3398V32.1283H27.5879Z",
    fill: "url(#paint14_linear_846_65)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2383 32.1543C29.1406 32.1543 29.0625 32.1283 28.9941 32.0892C28.9258 32.0502 28.8672 31.9981 28.8281 31.92C28.7891 31.8418 28.7598 31.7507 28.7402 31.6595C28.7207 31.5554 28.7109 31.4382 28.7109 31.308V30.3835C28.7109 30.2533 28.7207 30.1361 28.7402 30.0319C28.7598 29.9278 28.7891 29.8497 28.8281 29.7715C28.8672 29.6934 28.9258 29.6413 28.9941 29.6023C29.0625 29.5632 29.1504 29.5502 29.2383 29.5502C29.4238 29.5502 29.5605 29.6153 29.6484 29.7585C29.7363 29.9017 29.7754 30.1101 29.7754 30.3835V31.308C29.7754 31.4382 29.7656 31.5554 29.7461 31.6595C29.7266 31.7637 29.6973 31.8549 29.6582 31.92C29.6191 31.9981 29.5605 32.0502 29.4922 32.0892C29.4141 32.1413 29.3262 32.1543 29.2383 32.1543ZM29.0332 31.7377C29.0723 31.8158 29.1406 31.8549 29.2285 31.8549C29.3262 31.8549 29.3945 31.8158 29.4238 31.7377C29.4629 31.6595 29.4824 31.5424 29.4824 31.3991V30.2924C29.4824 30.1491 29.4629 30.0319 29.4238 29.9538C29.3848 29.8757 29.3164 29.8496 29.2187 29.8496C29.1211 29.8496 29.0527 29.8887 29.0137 29.9538C28.9746 30.0319 28.9551 30.1361 28.9551 30.2924V31.3991C28.9746 31.5424 28.9941 31.6595 29.0332 31.7377Z",
    fill: "url(#paint15_linear_846_65)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7812 32.1544C30.6934 32.1544 30.6152 32.1413 30.5566 32.1023C30.4883 32.0632 30.4395 32.0242 30.4004 31.9721C30.3613 31.92 30.3223 31.8419 30.3027 31.7507C30.2832 31.6596 30.2637 31.5684 30.2539 31.4643C30.2441 31.3601 30.2441 31.2559 30.2441 31.1257V30.4747C30.2441 29.8497 30.4297 29.5372 30.8008 29.5372C30.8887 29.5372 30.9668 29.5502 31.0352 29.5893C31.1035 29.6283 31.1523 29.6804 31.1914 29.7455C31.2305 29.8106 31.2598 29.8887 31.2793 29.9929C31.2988 30.084 31.3086 30.1882 31.3184 30.3184C31.3184 30.3314 31.3184 30.3575 31.3184 30.3965H31.0449V30.3184C31.0449 30.2533 31.0449 30.2012 31.0352 30.1622C31.0352 30.1231 31.0254 30.071 31.0156 30.032C31.0059 29.9929 30.9863 29.9538 30.9766 29.9278C30.957 29.9018 30.9375 29.8757 30.9082 29.8627C30.8789 29.8497 30.8398 29.8367 30.8008 29.8367C30.7422 29.8367 30.6934 29.8497 30.6641 29.8757C30.625 29.9018 30.5957 29.9408 30.5762 29.9929C30.5566 30.045 30.5371 30.0971 30.5371 30.1622C30.5273 30.2273 30.5273 30.2924 30.5273 30.3835V31.2038C30.5273 31.2689 30.5273 31.321 30.5273 31.3731C30.5273 31.4252 30.5371 31.4773 30.5371 31.5294C30.5469 31.5814 30.5566 31.6205 30.5664 31.6596C30.5762 31.6986 30.5957 31.7247 30.6152 31.7637C30.6348 31.7898 30.6641 31.8158 30.6934 31.8288C30.7227 31.8419 30.7617 31.8549 30.791 31.8549C30.8398 31.8549 30.8789 31.8419 30.9082 31.8158C30.9375 31.7898 30.9668 31.7637 30.9863 31.7247C31.0059 31.6856 31.0254 31.6335 31.0352 31.5814C31.0449 31.5294 31.0547 31.4643 31.0547 31.4122C31.0547 31.3601 31.0645 31.295 31.0645 31.2169V31.1257H30.791V30.8523H31.3379V32.1283H31.1328L31.0645 31.8549C31.0059 32.0502 30.918 32.1544 30.7812 32.1544Z",
    fill: "url(#paint16_linear_846_65)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0898 32.1283V31.308L31.6797 29.5632H31.9531L32.2266 30.8392L32.5 29.5632H32.7734L32.3633 31.308V32.1283H32.0898Z",
    fill: "url(#paint17_linear_846_65)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2969 32.1543C34.1699 32.1543 34.0723 32.1023 33.9941 31.9981C33.916 31.8939 33.8867 31.7507 33.8867 31.5814C33.8867 31.308 33.9746 31.0606 34.1602 30.8523C34.1504 30.8262 34.1309 30.7741 34.1016 30.696C34.0723 30.6179 34.043 30.5528 34.0332 30.5137C34.0137 30.4616 34.0039 30.4095 33.9844 30.3314C33.9648 30.2533 33.9648 30.1882 33.9648 30.1231C33.9648 29.9538 34.0039 29.8106 34.0723 29.7064C34.1504 29.6023 34.248 29.5502 34.375 29.5502C34.4922 29.5502 34.5898 29.5892 34.668 29.6804C34.7461 29.7715 34.7852 29.8887 34.7852 30.0319C34.7852 30.097 34.7754 30.1621 34.7656 30.2403C34.7461 30.3054 34.7266 30.3705 34.707 30.4226C34.6875 30.4747 34.6582 30.5267 34.6191 30.5918C34.5801 30.6569 34.5508 30.696 34.5313 30.7351C34.502 30.7741 34.4727 30.8132 34.4434 30.8523L34.7168 31.3991C34.7266 31.3601 34.7363 31.308 34.7461 31.2559C34.7559 31.2038 34.7656 31.1517 34.7656 31.1257C34.7656 31.0997 34.7754 31.0345 34.7852 30.9434H35.0586C35.0586 31.0606 35.0391 31.1778 35.0098 31.308C34.9805 31.4382 34.9316 31.5424 34.8926 31.6335C34.9512 31.7246 35 31.7637 35.0586 31.7637V32.1543C35.0391 32.1543 35.0195 32.1543 35.0098 32.1543C34.9902 32.1543 34.9805 32.1413 34.9609 32.1413C34.9414 32.1283 34.9316 32.1283 34.9219 32.1153C34.9121 32.1153 34.8926 32.1023 34.8828 32.0892C34.8633 32.0762 34.8535 32.0632 34.8438 32.0632C34.834 32.0632 34.8242 32.0502 34.8047 32.0241C34.7852 31.9981 34.7754 31.9981 34.7754 31.9851C34.7754 31.9851 34.7656 31.972 34.7461 31.946C34.7266 31.92 34.7168 31.9069 34.7168 31.9069C34.668 31.9851 34.6191 32.0502 34.541 32.0892C34.4629 32.1283 34.3848 32.1543 34.2969 32.1543ZM34.2969 31.8549C34.3848 31.8549 34.4629 31.7898 34.541 31.6726L34.4043 31.4121C34.3945 31.3861 34.375 31.3601 34.3555 31.321C34.3359 31.2819 34.3164 31.2429 34.2969 31.2168C34.2773 31.1778 34.2676 31.1517 34.2578 31.1257C34.2285 31.1778 34.1992 31.2429 34.1797 31.334C34.1602 31.4122 34.1504 31.5033 34.1504 31.5814C34.1504 31.6595 34.1602 31.7247 34.1797 31.7767C34.2188 31.8288 34.248 31.8549 34.2969 31.8549ZM34.3359 30.67C34.3848 30.5918 34.4238 30.5007 34.4531 30.3705C34.4824 30.2533 34.502 30.1361 34.502 30.0189C34.502 29.9668 34.4922 29.9148 34.4629 29.8887C34.4336 29.8497 34.4043 29.8366 34.3652 29.8366C34.3164 29.8366 34.2871 29.8627 34.2578 29.9148C34.2383 29.9668 34.2285 30.0319 34.2285 30.1101C34.2285 30.1752 34.2383 30.2403 34.248 30.3054C34.2578 30.3835 34.2676 30.4356 34.2871 30.4877C34.2969 30.5398 34.3164 30.5918 34.3359 30.67Z",
    fill: "url(#paint18_linear_846_65)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3184 32.1283V29.5632H36.5918V32.1283H36.3184Z",
    fill: "url(#paint19_linear_846_65)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1484 32.1283V29.5632H37.3535L37.832 31.1517V29.5632H38.1055V32.1283H37.9102L37.4219 30.4225V32.1283H37.1484Z",
    fill: "url(#paint20_linear_846_65)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6426 32.1283V29.5632H38.8477L39.3262 31.1517V29.5632H39.5996V32.1283H39.4043L38.916 30.4225V32.1283H38.6426Z",
    fill: "url(#paint21_linear_846_65)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6445 32.1543C40.5469 32.1543 40.4687 32.1283 40.4004 32.0892C40.332 32.0502 40.2734 31.9981 40.2344 31.92C40.1953 31.8418 40.166 31.7507 40.1465 31.6595C40.127 31.5554 40.1172 31.4382 40.1172 31.308V30.3835C40.1172 30.2533 40.127 30.1361 40.1465 30.0319C40.166 29.9278 40.1953 29.8497 40.2344 29.7715C40.2734 29.6934 40.332 29.6413 40.4004 29.6023C40.4687 29.5632 40.5566 29.5502 40.6445 29.5502C40.8301 29.5502 40.9668 29.6153 41.0547 29.7585C41.1426 29.9017 41.1816 30.1101 41.1816 30.3835V31.308C41.1816 31.4382 41.1719 31.5554 41.1523 31.6595C41.1328 31.7637 41.1035 31.8549 41.0644 31.92C41.0254 31.9981 40.9668 32.0502 40.8984 32.0892C40.8203 32.1413 40.7422 32.1543 40.6445 32.1543ZM40.4395 31.7377C40.4785 31.8158 40.5469 31.8549 40.6445 31.8549C40.7422 31.8549 40.8105 31.8158 40.8398 31.7377C40.8789 31.6595 40.8984 31.5424 40.8984 31.3991V30.2924C40.8984 30.1491 40.8789 30.0319 40.8398 29.9538C40.8008 29.8757 40.7324 29.8496 40.6348 29.8496C40.5371 29.8496 40.4687 29.8887 40.4297 29.9538C40.3906 30.0319 40.3711 30.1361 40.3711 30.2924V31.3991C40.3906 31.5424 40.4102 31.6595 40.4395 31.7377Z",
    fill: "url(#paint22_linear_846_65)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9629 32.1283L41.5527 29.5632H41.8262L42.0313 30.9434L42.0996 31.5814L42.168 30.9434L42.373 29.5632H42.6465L42.2363 32.1283H41.9629Z",
    fill: "url(#paint23_linear_846_65)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 32.1283L43.3008 29.5632H43.5742L43.9844 32.1283H43.7109L43.6035 31.4903H43.2617L43.1543 32.1283H42.8906ZM43.3008 31.2168H43.5742L43.4375 30.1231L43.3008 31.2168Z",
    fill: "url(#paint24_linear_846_65)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5605 32.1283V29.8887H44.2188V29.5632H45.1758V29.8887H44.834V32.1283H44.5605Z",
    fill: "url(#paint25_linear_846_65)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5859 32.1283V29.5632H45.8594V32.1283H45.5859Z",
    fill: "url(#paint26_linear_846_65)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9141 32.1543C46.8164 32.1543 46.7383 32.1283 46.6699 32.0892C46.6016 32.0502 46.543 31.9981 46.5039 31.92C46.4648 31.8418 46.4356 31.7507 46.416 31.6595C46.3965 31.5554 46.3867 31.4382 46.3867 31.308V30.3835C46.3867 30.2533 46.3965 30.1361 46.416 30.0319C46.4356 29.9278 46.4648 29.8497 46.5039 29.7715C46.543 29.6934 46.6016 29.6413 46.6699 29.6023C46.7383 29.5632 46.8262 29.5502 46.9141 29.5502C47.0996 29.5502 47.2363 29.6153 47.3242 29.7585C47.4121 29.9017 47.4512 30.1101 47.4512 30.3835V31.308C47.4512 31.4382 47.4414 31.5554 47.4219 31.6595C47.4023 31.7637 47.373 31.8549 47.334 31.92C47.2949 31.9981 47.2363 32.0502 47.168 32.0892C47.0996 32.1413 47.0117 32.1543 46.9141 32.1543ZM46.7188 31.7377C46.7578 31.8158 46.8262 31.8549 46.9238 31.8549C47.0215 31.8549 47.0898 31.8158 47.1191 31.7377C47.1582 31.6595 47.1777 31.5424 47.1777 31.3991V30.2924C47.1777 30.1491 47.1582 30.0319 47.1191 29.9538C47.0801 29.8757 47.0117 29.8496 46.9141 29.8496C46.8164 29.8496 46.7481 29.8887 46.709 29.9538C46.6699 30.0319 46.6504 30.1361 46.6504 30.2924V31.3991C46.6602 31.5424 46.6797 31.6595 46.7188 31.7377Z",
    fill: "url(#paint27_linear_846_65)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9492 32.1283V29.5632H48.1543L48.6328 31.1517V29.5632H48.9063V32.1283H48.7109L48.2227 30.4225V32.1283H47.9492Z",
    fill: "url(#paint28_linear_846_65)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0391 32.1283L50.4492 29.5632H50.7227L51.1328 32.1283H50.8594L50.752 31.4903H50.4102L50.3027 32.1283H50.0391ZM50.4492 31.2168H50.7227L50.5859 30.1231L50.4492 31.2168Z",
    fill: "url(#paint29_linear_846_65)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0605 32.1543C51.8848 32.1543 51.7578 32.0892 51.6602 31.946C51.5723 31.8158 51.5137 31.6205 51.5039 31.3861L51.7773 31.295C51.7871 31.6595 51.8848 31.8418 52.0508 31.8418C52.1875 31.8418 52.2559 31.7507 52.2559 31.5684C52.2559 31.5163 52.2461 31.4642 52.2363 31.4121C52.2266 31.3601 52.207 31.321 52.1875 31.2819C52.168 31.2429 52.1484 31.2168 52.1289 31.1908C52.1094 31.1648 52.0801 31.1387 52.0508 31.0996L51.709 30.7351C51.6504 30.67 51.5918 30.5918 51.5625 30.4877C51.5234 30.3835 51.5039 30.2663 51.5039 30.1361C51.5039 29.9408 51.5527 29.7976 51.6406 29.6804C51.7285 29.5632 51.8457 29.5111 51.9922 29.5111C52.1484 29.5111 52.2754 29.5632 52.3633 29.6674C52.4512 29.7715 52.5098 29.9148 52.5293 30.097C52.5293 30.1231 52.5293 30.1491 52.5391 30.1752L52.2656 30.2663C52.2656 30.2533 52.2656 30.2273 52.2559 30.1882C52.2461 30.071 52.2168 29.9799 52.1777 29.9148C52.1387 29.8496 52.0703 29.8106 51.9922 29.8106C51.9238 29.8106 51.875 29.8366 51.8359 29.8887C51.7969 29.9408 51.7773 30.0059 51.7773 30.097C51.7773 30.2403 51.8262 30.3575 51.9141 30.4616L52.2559 30.8262C52.4414 31.0215 52.5293 31.2559 52.5293 31.5293C52.5293 31.7116 52.4902 31.8679 52.4023 31.972C52.3242 32.1023 52.207 32.1543 52.0605 32.1543Z",
    fill: "url(#paint30_linear_846_65)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5938 32.1283L54.0039 29.5632H54.2773L54.6875 32.1283H54.4141L54.3066 31.4903H53.9648L53.8574 32.1283H53.5938ZM54.0039 31.2168H54.2773L54.1406 30.1231L54.0039 31.2168Z",
    fill: "url(#paint31_linear_846_65)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 32.1283V29.5632H56.2988C56.6211 29.5632 56.7773 29.8106 56.7773 30.2923C56.7773 30.5007 56.7383 30.6569 56.6504 30.7741C56.5723 30.8783 56.4453 30.9434 56.2891 30.9434H56.0937V32.1283H55.8203ZM56.0937 30.6699H56.1621C56.2207 30.6699 56.2793 30.6699 56.3184 30.6569C56.3574 30.6439 56.3965 30.6309 56.4258 30.6048C56.4551 30.5788 56.4746 30.5397 56.4941 30.4877C56.5039 30.4356 56.5137 30.3835 56.5137 30.3054C56.5137 30.2142 56.5039 30.1361 56.4941 30.084C56.4844 30.0319 56.4648 29.9798 56.4355 29.9408C56.4062 29.9017 56.377 29.8757 56.3281 29.8626C56.2891 29.8496 56.2305 29.8366 56.1621 29.8366H56.0937V30.6699Z",
    fill: "url(#paint32_linear_846_65)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.207 32.1283V29.5632H57.5488C57.7539 29.5632 57.9102 29.6153 58.0078 29.7194C58.1152 29.8236 58.1641 30.0059 58.1641 30.2533C58.1641 30.4095 58.1445 30.5397 58.1055 30.6309C58.0664 30.735 58.0078 30.8001 57.9297 30.8392L58.2422 32.1153H57.9687L57.6953 30.9304H57.4902V32.1153H57.207V32.1283ZM57.4805 30.6699H57.5488C57.666 30.6699 57.7539 30.6439 57.8027 30.5788C57.8516 30.5137 57.8906 30.4095 57.8906 30.2663C57.8906 30.1231 57.8613 30.0189 57.8027 29.9538C57.7441 29.8887 57.6562 29.8626 57.5488 29.8626H57.4805V30.6699Z",
    fill: "url(#paint33_linear_846_65)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6719 32.1283V29.5632H58.9453V32.1283H58.6719Z",
    fill: "url(#paint34_linear_846_65)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32.1543C59.9023 32.1543 59.8242 32.1283 59.7559 32.0892C59.6875 32.0502 59.6289 31.9981 59.5898 31.92C59.5508 31.8418 59.5215 31.7507 59.502 31.6595C59.4824 31.5684 59.4727 31.4382 59.4727 31.308V30.3835C59.4727 30.2533 59.4824 30.1361 59.502 30.0319C59.5215 29.9278 59.5508 29.8497 59.5898 29.7715C59.6289 29.6934 59.6875 29.6413 59.7559 29.6023C59.8242 29.5632 59.9121 29.5502 60 29.5502C60.1855 29.5502 60.3223 29.6153 60.4102 29.7585C60.4981 29.9017 60.5371 30.1101 60.5371 30.3835V31.308C60.5371 31.4382 60.5273 31.5554 60.5078 31.6595C60.4883 31.7637 60.459 31.8549 60.4199 31.92C60.3809 31.9981 60.3223 32.0502 60.2539 32.0892C60.1758 32.1413 60.0977 32.1543 60 32.1543ZM59.7949 31.7377C59.834 31.8158 59.9023 31.8549 59.9902 31.8549C60.0879 31.8549 60.1563 31.8158 60.1953 31.7377C60.2344 31.6595 60.2539 31.5424 60.2539 31.3991V30.2924C60.2539 30.1491 60.2344 30.0319 60.1953 29.9538C60.1563 29.8757 60.0879 29.8496 59.9902 29.8496C59.8926 29.8496 59.8242 29.8887 59.7852 29.9538C59.7461 30.0319 59.7266 30.1361 59.7266 30.2924V31.3991C59.7461 31.5424 59.7559 31.6595 59.7949 31.7377Z",
    fill: "url(#paint35_linear_846_65)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0352 32.1283V29.5632H61.377C61.582 29.5632 61.7383 29.6153 61.8359 29.7194C61.9434 29.8236 61.9922 30.0059 61.9922 30.2533C61.9922 30.4095 61.9727 30.5397 61.9336 30.6309C61.8945 30.735 61.8359 30.8001 61.7578 30.8392L62.0703 32.1153H61.7969L61.5234 30.9304H61.3184V32.1153H61.0352V32.1283ZM61.3086 30.6699H61.377C61.4941 30.6699 61.582 30.6439 61.6309 30.5788C61.6895 30.5137 61.7188 30.4095 61.7188 30.2663C61.7188 30.1231 61.6895 30.0189 61.6309 29.9538C61.5723 29.8887 61.4844 29.8626 61.377 29.8626H61.3086V30.6699Z",
    fill: "url(#paint36_linear_846_65)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 32.1283V29.5632H62.7734V32.1283H62.5Z",
    fill: "url(#paint37_linear_846_65)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5352 32.1283V29.8887H63.1934V29.5632H64.1504V29.8887H63.8086V32.1283H63.5352Z",
    fill: "url(#paint38_linear_846_65)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8242 32.1283V31.308L64.4141 29.5632H64.6875L64.9609 30.8392L65.2344 29.5632H65.5078L65.0977 31.308V32.1283H64.8242Z",
    fill: "url(#paint39_linear_846_65)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_846_65",
    x1: 24.2816,
    y1: 13.4608,
    x2: 24.2816,
    y2: 28.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5954,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5956,
    stopColor: "#D3EE77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_846_65",
    x1: 37.1049,
    y1: 13.4608,
    x2: 37.1049,
    y2: 28.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_846_65",
    x1: 49.3649,
    y1: 13.4608,
    x2: 49.3649,
    y2: 28.4516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_846_65",
    x1: 60.4391,
    y1: 13.4608,
    x2: 60.4391,
    y2: 28.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_846_65",
    x1: 9.70286,
    y1: 13.4608,
    x2: 9.70286,
    y2: 30.3214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_846_65",
    x1: 6.38956,
    y1: 13.7017,
    x2: 6.38956,
    y2: 29.7819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#E7D28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_846_65",
    x1: -0.00313477,
    y1: 9.83328,
    x2: 59.6888,
    y2: 9.83328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_846_65",
    x1: 2.31582,
    y1: 3.88546,
    x2: 36.0983,
    y2: 3.88546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005618,
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3045,
    stopColor: "#F8F0BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4072,
    stopColor: "#E7D28E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8708,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_846_65",
    x1: 19.4724,
    y1: 29.2359,
    x2: 19.4724,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5202,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852603,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949207,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960799,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_846_65",
    x1: 20.731,
    y1: 29.2359,
    x2: 20.731,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833282,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895109,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941479,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_846_65",
    x1: 22.0265,
    y1: 29.2359,
    x2: 22.0265,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751541,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87646,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879747,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886322,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902759,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.912621,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92577,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93892,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93892,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955356,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998092,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_846_65",
    x1: 23.5077,
    y1: 29.2359,
    x2: 23.5077,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752135,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.810097,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910565,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_846_65",
    x1: 25.0422,
    y1: 29.2359,
    x2: 25.0422,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837147,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_846_65",
    x1: 26.5572,
    y1: 29.2359,
    x2: 26.5572,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690306,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755996,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_846_65",
    x1: 27.9693,
    y1: 29.2359,
    x2: 27.9693,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5199,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5201,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745677,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764873,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.787907,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833975,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883882,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89156,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89156,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895399,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910755,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914594,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_846_65",
    x1: 29.2342,
    y1: 29.2359,
    x2: 29.2342,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078225,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104267,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5091,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5092,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5093,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5094,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5175,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5176,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5177,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5178,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5182,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770733,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916767,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963342,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963442,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_846_65",
    x1: 30.7837,
    y1: 29.236,
    x2: 30.7837,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687241,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689901,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705866,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713848,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72183,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748437,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753758,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761741,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761741,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783026,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785687,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793669,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804312,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812294,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828258,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_846_65",
    x1: 32.228,
    y1: 29.2359,
    x2: 32.228,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682103,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714386,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760503,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_846_65",
    x1: 34.4693,
    y1: 29.2359,
    x2: 34.4693,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_846_65",
    x1: 36.452,
    y1: 29.2359,
    x2: 36.452,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_846_65",
    x1: 37.6279,
    y1: 29.2359,
    x2: 37.6279,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#ACEB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292989,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_846_65",
    x1: 39.1279,
    y1: 29.2359,
    x2: 39.1279,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0005,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654509,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692509,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_846_65",
    x1: 40.643,
    y1: 29.2359,
    x2: 40.643,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916367,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916467,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916567,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_846_65",
    x1: 42.1024,
    y1: 29.2359,
    x2: 42.1024,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767665,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809259,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83951,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_846_65",
    x1: 43.4382,
    y1: 29.2359,
    x2: 43.4382,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_846_65",
    x1: 44.6947,
    y1: 29.2359,
    x2: 44.6947,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_846_65",
    x1: 45.7257,
    y1: 29.2359,
    x2: 45.7257,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5181,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5182,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748732,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75323,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757728,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77572,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789214,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.793712,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829696,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84319,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865681,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.870179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888171,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892669,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906163,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.924155,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937649,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942147,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946645,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955642,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96014,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964638,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987128,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_846_65",
    x1: 46.9166,
    y1: 29.2359,
    x2: 46.9166,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_846_65",
    x1: 48.4317,
    y1: 29.2359,
    x2: 48.4317,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151042,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_846_65",
    x1: 50.5905,
    y1: 29.2359,
    x2: 50.5905,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0169492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0338983,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0508475,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677966,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0847458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101695,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.118644,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135593,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169492,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186441,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.220339,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237088,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253637,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253737,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253837,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254037,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254137,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254237,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270986,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271086,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271186,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289597,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305085,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322034,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338983,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355932,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372881,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38983,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40678,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423729,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.440678,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457627,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474576,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491425,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491525,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508475,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525424,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542373,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559322,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576271,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59322,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610169,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627119,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644068,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661017,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694915,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711864,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728814,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745763,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762712,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779661,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79661,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813559,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830508,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847458,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864407,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881356,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898305,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915254,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932203,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949153,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966102,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982951,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983051,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_846_65",
    x1: 52.0245,
    y1: 29.2359,
    x2: 52.0245,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68632,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754675,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763219,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814485,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827301,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84439,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891384,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_846_65",
    x1: 54.1441,
    y1: 29.2359,
    x2: 54.1441,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#FFFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5095,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5096,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5097,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5182,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5183,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5184,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5186,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5187,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5188,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5189,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5191,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5192,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5194,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5196,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9994,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_846_65",
    x1: 56.3028,
    y1: 29.2359,
    x2: 56.3028,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_846_65",
    x1: 57.718,
    y1: 29.2359,
    x2: 57.718,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_846_65",
    x1: 58.8059,
    y1: 29.2359,
    x2: 58.8059,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458433,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582556,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_846_65",
    x1: 59.9969,
    y1: 29.2359,
    x2: 59.9969,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489683,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_846_65",
    x1: 61.5464,
    y1: 29.2359,
    x2: 61.5464,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00480833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00490833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00500833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00510833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00530833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0364583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0365583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0366583,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0572917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0573917,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5099,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9996,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_846_65",
    x1: 62.6343,
    y1: 29.2359,
    x2: 62.6343,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479067,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4992,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4993,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4994,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4995,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4997,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4998,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5624,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916667,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_846_65",
    x1: 63.6718,
    y1: 29.2359,
    x2: 63.6718,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_846_65",
    x1: 64.9615,
    y1: 29.2359,
    x2: 64.9615,
    y2: 32.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHulkLogo);
export default __webpack_public_path__ + "static/media/hulk-logo.1282cb323c6497425d9a2cfcfc58facd.svg";
export { ForwardRef as ReactComponent };